








import Vue from 'vue';
import Spinner from '@/components/common/Spinner.vue';
import CloseWindowButton from '@/components/common/CloseWindowButton.vue';
import router from '@/router';

export default Vue.extend({
  name: 'LoadingPage',
  components: {
    Spinner,
    CloseWindowButton
  },
  mounted() {
    if (this.$store.state.isShortcut != undefined) {
      if (this.$store.state.isShortcut) {
        router.replace('Instructions');
      } else {
        router.replace('Pairing');
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingPage.vue